/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';

import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';

export default function GroupsList() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [name, setName] = useState('Group 1');

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = event => {
    event.currentTarget.id && setName(event.currentTarget.id);
    setAnchorEl(null);
  };
  return (
    <>
      <Button aria-haspopup="true" onClick={handleClick} endIcon={<KeyboardArrowDownOutlinedIcon color="primary" />}>
        {name}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={handleClose} id="All Groups">
          All Groups
        </MenuItem>
        <MenuItem onClick={handleClose} id="Group 1">
          Group 1
        </MenuItem>
        <MenuItem onClick={handleClose} id="Group 2">
          Group 2
        </MenuItem>
        <MenuItem onClick={handleClose} id="Group 3">
          Group 3
        </MenuItem>
      </Menu>
    </>
  );
}
